export default (function (doc) {
  if (doc === void 0) {
    doc = document;
  }

  return doc.activeElement;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-lib/es/query/activeElement.js
// module id = 2165
// module chunks = 33